import { capitalCase } from "change-case";

import { loadLocale } from "@smart/itops-locale-dom";

export type SettingsTabKey =
  | "web-enquiries"
  | "client-messages"
  | "general"
  | "branding"
  | "voice-guide";

export type SettingsTab = { key: SettingsTabKey; label: string };

export const useSettingsTabs = (): SettingsTab[] => {
  const { terms } = loadLocale();

  return [
    { key: "web-enquiries", label: `Web ${capitalCase(terms.enquiry.plural)}` },
    { key: "client-messages", label: "Message Templates" },
    { key: "general", label: "General" },
    { key: "branding", label: "Branding" },
    { key: "voice-guide", label: "Voice-Guide" },
  ];
};
